import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Translation, TranslocoService } from '@jsverse/transloco';

export const managementAdsTranslocoResolver: ResolveFn<Translation> = () => {
    const transloco = inject(TranslocoService);
    return transloco.load(`managementAds/${transloco.getActiveLang()}`);
};
